module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="zmags-section wide">\n    <header class="title-field">\n        <h1>Set Up Integrations</h1>\n    </header>\n\n    <div class="tabs tabs-integrations">\n        <span class="tab active" data-tab-name="add-ons">Add-ons</span>\n        <span class="tab" data-tab-name="custom-actions">Custom JavaScript Actions</span>\n    </div>\n\n    <div class="tab-pane add-ons active" data-tab-pane="add-ons"></div>\n\n    <div class="tab-pane custom-actions" data-tab-pane="custom-actions"></div>\n</div>\n\n<footer class="default-footer"></footer>\n';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/editor/ui/settings/integrations/IntegrationsView.tpl
// module id = 3075
// module chunks = 0